namespace RedBullMOBILE360.Sms {
    export interface WhiteListRow {
        Id?: number;
        WhitelistName?: string;
        CreationDate?: string;
        LastUpdateDate?: string;
        CreatedBy?: number;
    }

    export namespace WhiteListRow {
        export const idProperty = 'Id';
        export const nameProperty = 'WhitelistName';
        export const localTextPrefix = 'Sms.WhiteList';
        export const lookupKey = 'Sms.WhiteList';

        export function getLookup(): Q.Lookup<WhiteListRow> {
            return Q.getLookup<WhiteListRow>('Sms.WhiteList');
        }
        export const deletePermission = 'Sms:AddWhitelist';
        export const insertPermission = 'Sms:AddWhitelist';
        export const readPermission = 'Sms:WhiteList';
        export const updatePermission = 'Sms:AddWhitelist';

        export declare const enum Fields {
            Id = "Id",
            WhitelistName = "WhitelistName",
            CreationDate = "CreationDate",
            LastUpdateDate = "LastUpdateDate",
            CreatedBy = "CreatedBy"
        }
    }
}
